import * as actionTypes from "./actionTypes";
import api from "./api";
import { sendHttpRequest } from "actions/actionCreators/httpActions";
import { showError } from "actions/actionCreators/snackbarActions";

export function loadUserRights() {
  return async (dispatch, getState) => {
    let userRights = getState().userRights;
    if (userRights.loaded || userRights.loading) return;

    try {
      dispatch({ type: actionTypes.LOAD_USER_RIGHTS_STARTED });
      userRights = await dispatch(sendHttpRequest(api.loadUserRights()));

      dispatch({ type: actionTypes.LOAD_USER_RIGHTS_SUCCESS, payload: userRights });
    } catch (error) {
      dispatch(showError(error.message, error.correlationId));
      throw error;
    }
  };
}
